import { immer } from 'zustand/middleware/immer'
import { shallow } from 'zustand/shallow'
import { createWithEqualityFn } from 'zustand/traditional'

type State = {
  selectedDiscard: string[]
  selectedBatchId: string | null
}

type Actions = {
  reset: () => void
}

const initialState: State = {
  selectedBatchId: null,
  selectedDiscard: [],
}

export const useBatches = createWithEqualityFn(
  immer<State & Actions>((set) => {
    return {
      ...initialState,

      reset() {
        set(initialState)
      },
    }
  }),
  shallow,
)
